function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.76684 2.23333C8.68018 1.14667 7.14018 0.52 5.44684 0.693333C3.00018 0.94 0.986844 2.92667 0.71351 5.37333C0.346844 8.60667 2.84684 11.3333 6.00018 11.3333C8.12684 11.3333 9.95351 10.0867 10.8068 8.29333C11.0202 7.84667 10.7002 7.33333 10.2068 7.33333C9.96018 7.33333 9.72684 7.46667 9.62018 7.68667C8.86684 9.30667 7.06018 10.3333 5.08684 9.89333C3.60684 9.56667 2.41351 8.36 2.10018 6.88C1.54018 4.29333 3.50684 2 6.00018 2C7.10684 2 8.09351 2.46 8.81351 3.18667L7.80684 4.19333C7.38684 4.61333 7.68018 5.33333 8.27351 5.33333H10.6668C11.0335 5.33333 11.3335 5.03333 11.3335 4.66667V2.27333C11.3335 1.68 10.6135 1.38 10.1935 1.8L9.76684 2.23333Z",
  fill: "#3F5E20"
});

var SvgRefreshIcon = function SvgRefreshIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefreshIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh_icon.1d5efd5b.svg";
export { ForwardRef as ReactComponent };